<template>

    <v-panel title="Button">
        <v-section name="Button" expanded>
            <v-action-text type="text" />
            <v-action-text type="link" />
            <v-action-size type="border-radius" :min="0" :max="100" />
        </v-section>
        <v-section name="Text">
            <v-action-font-style />
            <v-action-font-family />
            <v-action-size type="font-size" :min="1" :max="100" />
            <v-action-size type="letter-spacing" :min="0" :max="100" />
            <v-action-size type="line-height" :min="0" :max="100" />
        </v-section>
        <v-section-color />
        <v-section name="Position">
            <v-action-align :container="true" />
        </v-section>
        <v-section name="Padding">
            <v-action-padding />
        </v-section>
        <v-section-block />
    </v-panel>

</template>

<script>

import ActionAlign from './actions/ActionAlign';
import ActionFontFamily from './actions/ActionFontFamily';
import ActionFontStyle from './actions/ActionFontStyle';
import ActionPadding from './actions/ActionPadding';
import ActionSize from './actions/ActionSize';
import ActionText from './actions/ActionText';
import Panel from './Panel';
import Section from './sections/Section';
import SectionBlock from './sections/SectionBlock';
import SectionColor from './sections/SectionColor';

export default {

    components: {
        'v-action-align': ActionAlign,
        'v-action-font-family': ActionFontFamily,
        'v-action-font-style': ActionFontStyle,
        'v-action-padding': ActionPadding,
        'v-action-size': ActionSize,
        'v-action-text': ActionText,
        'v-panel': Panel,
        'v-section': Section,
        'v-section-block': SectionBlock,
        'v-section-color': SectionColor,
    },

}

</script>